// Bloqueo de scroll del viewport para modales/overlays, con dos cuidados "elegantes":
// 1. Compensa el ancho de la scrollbar al ocultarla (evita el salto horizontal del
//    contenido cuando el modal abre).
// 2. Contador de bloqueos: con modales apilados, recién libera el scroll cuando se
//    cierra el último (no al cerrar uno intermedio).
//
// El scroller del viewport es <html> (documentElement) — por eso el `overflow:hidden`
// va ahí (ponerlo en body no frena el scroll de fondo). En cambio, el padding de
// compensación va en <body>: el padding del root element desplaza a los elementos
// `position:fixed` (dejaría el backdrop más angosto), el de body no.

let lockCount = 0;
let savedHtmlOverflow = '';
let savedBodyPaddingRight = '';

export function lockScroll(): void {
  lockCount += 1;
  if (lockCount > 1) return; // ya bloqueado por un modal previo

  const html = document.documentElement;
  const body = document.body;
  const scrollbarWidth = window.innerWidth - html.clientWidth;

  savedHtmlOverflow = html.style.overflow;
  savedBodyPaddingRight = body.style.paddingRight;

  html.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    const currentPadding = Number.parseFloat(getComputedStyle(body).paddingRight) || 0;
    body.style.paddingRight = `${currentPadding + scrollbarWidth}px`;
  }
}

export function unlockScroll(): void {
  if (lockCount === 0) return;
  lockCount -= 1;
  if (lockCount > 0) return; // aún hay modales abiertos

  document.documentElement.style.overflow = savedHtmlOverflow;
  document.body.style.paddingRight = savedBodyPaddingRight;
}
